<template>
    <h1>Terms of Service</h1>
</template>